import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Route } from '@/types/route.types';
import { formatDate } from '@/lib/formatters';
import { MapPin, ArrowLeft, Calendar, Clock } from 'lucide-react';

interface RouteInfoCardProps {
  route: Route;
}

export function RouteInfoCard({ route }: RouteInfoCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="h-5 w-5" />
          معلومات المسار
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* From Zone */}
        <div className="space-y-1">
          <label className="text-sm text-muted-foreground">منطقة الانطلاق</label>
          <div className="flex items-center gap-2 p-3 bg-muted/50 rounded-lg">
            <div className="h-8 w-8 rounded-full bg-green-500/10 flex items-center justify-center">
              <MapPin className="h-4 w-4 text-green-500" />
            </div>
            <div>
              <p className="font-medium">{route.from_zone?.name || '-'}</p>
              <p className="text-xs text-muted-foreground font-mono">{route.from_zone?.code}</p>
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div className="flex justify-center">
          <div className="h-8 w-8 rounded-full bg-muted flex items-center justify-center">
            <ArrowLeft className="h-4 w-4 text-muted-foreground rotate-90" />
          </div>
        </div>

        {/* To Zone */}
        <div className="space-y-1">
          <label className="text-sm text-muted-foreground">منطقة الوصول</label>
          <div className="flex items-center gap-2 p-3 bg-muted/50 rounded-lg">
            <div className="h-8 w-8 rounded-full bg-red-500/10 flex items-center justify-center">
              <MapPin className="h-4 w-4 text-red-500" />
            </div>
            <div>
              <p className="font-medium">{route.to_zone?.name || '-'}</p>
              <p className="text-xs text-muted-foreground font-mono">{route.to_zone?.code}</p>
            </div>
          </div>
        </div>

        {/* Distance & Time */}
        {(route.estimated_distance_km || route.estimated_time_minutes) && (
          <div className="grid grid-cols-2 gap-3 pt-2">
            {route.estimated_distance_km && (
              <div className="p-3 bg-muted/50 rounded-lg text-center">
                <p className="text-lg font-semibold">{route.estimated_distance_km} كم</p>
                <p className="text-xs text-muted-foreground">المسافة</p>
              </div>
            )}
            {route.estimated_time_minutes && (
              <div className="p-3 bg-muted/50 rounded-lg text-center">
                <div className="flex items-center justify-center gap-1">
                  <Clock className="h-4 w-4 text-muted-foreground" />
                  <p className="text-lg font-semibold">{route.estimated_time_minutes}</p>
                </div>
                <p className="text-xs text-muted-foreground">دقيقة</p>
              </div>
            )}
          </div>
        )}

        {/* Timestamps */}
        <div className="pt-4 border-t space-y-2">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Calendar className="h-4 w-4" />
            <span>أنشئ: {formatDate(route.created_at)}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Calendar className="h-4 w-4" />
            <span>آخر تحديث: {formatDate(route.updated_at)}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
